export default {"src":"/_next/static/media/dairy-free.ca23950a.svg","height":16,"width":16};